import { Tooltip } from "@/components/ui/tooltip";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: { id: number };
  handleDetail: (id: number) => void;
  href: string;
}

export const EstablishmentFieldRequestActions = ({ handleDetail, item, href }: Props) => {
  const handleMouseDown = (e: React.MouseEvent) => {
    if (e.button === 1) {
      e.preventDefault();
      window.open(href, "_blank");
    }
  };

  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex>
        <Eye
          cursor="pointer"
          onClick={() => handleDetail(item.id)}
          onMouseDown={handleMouseDown}
          data-testid="establishment-field-request-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
